import 'pages/e2/e2.prototype.css'

import { MdDehaze } from '@react-icons/all-files/md/MdDehaze'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import type { UserReducer } from '@disco/state-management/reducers/user'
import { isDeviceTypePhone } from '@disco/state-management/selectors/app'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'

import type { User } from 'types/user'

import MobileShortlistsSwitch from 'components/explorer/mobile-shortlists-switch'
import HeaderNotifications from 'components/header/header-notifications'
import HeaderTrialNotification from 'components/header/header-trial-notification'
import HeaderHelpMenu from 'components/header/help-menu'
import TrialExpiredModal from 'components/header/trial-expired-modal'

import SearchWrapper from 'containers/SearchWrapper'
import SidebarDropWrapper from 'containers/SidebarDropWrapper'

import { useSelector } from 'hooks/use-redux'

import HeaderInviteLinkButton from './header-invite-link-button'
import HeaderSearch from './search'
import { enableUserInvites } from './utils'

function getTrialStatus(user, isSubscriber) {
  const {
    private_metadata: { trial_period },
    stats: { trial_started_at, trial_ends_at },
  } = user.business
  if (isSubscriber) return null
  const end = trial_ends_at || trial_started_at + (trial_period || 30)
  return {
    end,
  }
}

type Props = {
  app: Record<string, any>
  user: User | UserReducer
  sidebarOpen: boolean
  showSearch: boolean
  showActions: boolean
  showNotifications: boolean
  toggleSidebar: (...args: Array<any>) => any
  // TODO: `fullWidthHeader` is not used, consider removing
  fullWidthHeader?: boolean
  bannersHeightPx: number
  isSubscriber: boolean
}
export default function Header(props: Props): React.ReactElement<'div'> {
  const location = useLocation()
  const { showSearch, showNotifications, toggleSidebar, isSubscriber, user } =
    props
  const isPhone = useSelector(isDeviceTypePhone)
  const isSupportMenuFeatureEnabled = useFeatureEnabled('SUPPORT_MENU') // TODO: remove temporary rollout flag  https://disco-team.atlassian.net/browse/DISCO-3949

  const searchBlock = showSearch ? (
    <SearchWrapper>
      <HeaderSearch />
    </SearchWrapper>
  ) : null
  let trialNotification
  const trial = getTrialStatus(user, isSubscriber)
  const showTrialExpiredModal =
    props.app.launchedOnMobileDevice &&
    !location?.pathname?.includes('/settings/billing')

  if (showNotifications && !props.app.launchedOnMobileDevice) {
    if (trial) {
      trialNotification = <HeaderTrialNotification trialEnd={trial.end} />
    }
  }

  const showUserInviteLink = enableUserInvites(user)
  const hamburgerButton = isPhone ? (
    <SidebarDropWrapper
      sidebarOpen={props.app.sidebarOpen}
      toggleSidebar={toggleSidebar}
    >
      <button
        className="Header_HamburgerBtn"
        onClick={toggleSidebar}
        aria-label="Toggle sidebar"
      >
        <MdDehaze />
        <i className="Icon" />
      </button>
    </SidebarDropWrapper>
  ) : null
  return (
    <div
      className="topbar Header"
      data-banners-height-px={props.bannersHeightPx}
      aria-expanded={props.sidebarOpen && !isPhone}
      data-full-width={isPhone || null}
    >
      <div>{hamburgerButton}</div>
      <Link className="Header_Logo" to="/">
        {/* <MdDehaze /> */}
      </Link>
      {searchBlock}
      <div className="topbar-right">
        {trialNotification}
        {showTrialExpiredModal && trial?.end && (
          <TrialExpiredModal trialEnd={trial.end} />
        )}
        <div className="desktop-topbar-icons">
          {showUserInviteLink && (
            <div className="topbar-icon hidden-phone ">
              <HeaderInviteLinkButton />
            </div>
          )}
          {isSupportMenuFeatureEnabled ? null : (
            <div className="topbar-icon hidden-phone">
              <HeaderHelpMenu />
            </div>
          )}
          <div className="topbar-icon hidden-phone ">
            <HeaderNotifications />
          </div>
        </div>
        <MobileShortlistsSwitch />
      </div>
    </div>
  )
}
